import CabeceraPagos from "./CabeceraPagos"
import TablaMovimientos from "./TablaMovimientos"
const Pagos = () => {
    return (
        <div>
            <h4>Información de pagos</h4>
            <CabeceraPagos />
            <h4>Historial de pagos</h4>
            <TablaMovimientos />
        </div>
    )
}
export default Pagos